<template lang="pug">
modal(v-if="cliente", :max-width="400")
	.card.text-left
		.card-header.bg-info
			span.fa.fa-user.mr-2
			| Datos del cliente
			button.close(@click="cerrar") &times;
		.card-body
			.alert.alert-info
				b Debes seleccionar la información a importar
		table.m-0.table.table-hover(v-if="cliente.telefonos.length > 1")
			thead.bg-dark.text-white
				tr
					th Teléfono
			tbody
				tr(v-for="(telefono, i) in cliente.telefonos", :key="i")
					td.opcion(:class="(telefonoSeleccionado === i) ? 'bg-success text-white' : ''", @click="asignar('Telefono', telefono.telefono, i)")
						span.fa.fa-phone.mr-2
						| {{telefono.telefono}}
		table.m-0.table.table-hover(v-if="cliente.emails.length > 1")
			thead.bg-dark.text-white
				tr
					th E-mail
			tbody
				tr(v-for="(email, i) in cliente.emails", :key="i")
					td.opcion(:class="(emailSeleccionado === i) ? 'bg-success text-white' : ''", @click="asignar('Email', email.email, i)")
						span.fa.fa-envelope.mr-2
						| {{email.email}}
		.card-footer
			button.btn.btn-sm.btn-primary(@click="cerrar")
				span.fa.fa-check.mr-2
				| Listo

</template>


<script>
export default {
	props: ['ClienteID'],
	data () {
		return {
			cliente: null,
			telefonoSeleccionado: null,
			emailSeleccionado: null
		}
	},
	created () {
		if (!this.ClienteID) {
			this.$error('Error', 'Debes proporcionar un ID de cliente')
			this.cerrar()
		} else {
			this.getCliente()
		}
	},
	methods: {
		getCliente () {
			this.$http.get('gestion-clientes/php/api/get-cliente.php?ID=' + this.ClienteID)
				.then(res => {
					const cliente = res.data.cliente

					this.asignar('NombreCliente', cliente.cliente)
					this.asignar('Representante', cliente.nombre)
					this.asignar('CIF', cliente.CIF)

					if (cliente.facturacion) {
						this.asignar('IBAN', cliente.facturacion.cuenta)
					}

					if (cliente.telefonos && cliente.telefonos.length === 1) {
						this.asignar('Telefono', cliente.telefonos[0].telefono)
					} else if (cliente.telefonos && cliente.telefonos.length > 1) {
						this.cliente = cliente
					}

					if (cliente.emails && cliente.emails.length === 1) {
						this.asignar('Email', cliente.emails[0].email)
					} else if (cliente.emails && cliente.emails.length > 1) {
						this.cliente = cliente
					}

					// Ahora pasamos la dirección del cliente
					if (!cliente.place_id) {
						this.asignar('Direccion', this.parseaDireccion(cliente.direccion))
					} else {
						this.asignar('Direccion', cliente.direccion.direccion_formateada)
					}

					if (!this.cliente) {
						this.cerrar()
					}
				})
				.catch(e => {
					console.error(e)
					this.$responseError(e)
				})
		},
		parseaDireccion (direccion) {
			if (direccion.via) {
				let dir = ''
				dir = direccion.via
				dir = (direccion.numero) ? dir + ', nº ' + direccion.numero : dir
				dir = (direccion.esc) ? dir + ', esc. ' + direccion.esc : dir
				dir = (direccion.piso) ? dir + ', ' + direccion.piso + ' piso' : dir
				dir = (direccion.puerta) ? dir + ' ' + direccion.puerta : dir
				dir = (direccion.cp) ? dir + '\n' + 'C.P. ' + direccion.cp : dir
				dir = (direccion.localidad) ? dir + '\n' + direccion.localidad : dir
				dir = (direccion.region) ? dir + '\n' + direccion.region : dir
				dir = (direccion.pais) ? dir + '\n' + direccion.pais.toUpperCase() : dir
				dir = (direccion.indicaciones) ? dir + '\n-\n' + direccion.indicaciones : dir
				return dir
			} else {
				return direccion.indicaciones
			}
		},
		asignar (campo, dato, indice) {
			this.$emit('asociar', {campo: campo, dato: dato})

			if (campo === 'Telefono') {
				this.telefonoSeleccionado = indice
			} else if (campo === 'Email') {
				this.emailSeleccionado = indice
			}
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.opcion {
	cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/cliente/seleccionaDatos.vue